import Utils from "../../../../../shared/utils"

export const IMAGE_URL = Utils.buildProductPageImageLink("mort/premium-mort/first-section-desk.png")

export const MAIN_TITLE_ICON = Utils.buildProductPageImageLink("icons/premium-house-icon.svg")